var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C36.2435 0 40.3131 1.68571 43.3137 4.68629C46.3143 7.68687 48 11.7565 48 16C48 20.2435 46.3143 24.3131 43.3137 27.3137C40.3131 30.3143 36.2435 32 32 32C27.7565 32 23.6869 30.3143 20.6863 27.3137C17.6857 24.3131 16 20.2435 16 16C16 11.7565 17.6857 7.68687 20.6863 4.68629C23.6869 1.68571 27.7565 0 32 0ZM32 40C49.68 40 64 47.16 64 56V64H0V56C0 47.16 14.32 40 32 40ZM12 72H20V80H12V72ZM28 72H36V80H28V72ZM44 72H52V80H44V72Z",
    fill: "#8DAA6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualImage);
export default __webpack_public_path__ + "static/media/individualImage.67b05cfa244e1357b9336bc5c2d12807.svg";
export { ForwardRef as ReactComponent };